import { ref, onMounted, computed } from "vue";
import { useStore } from "vuex";
import moment from "moment";
import $ from "jquery";

export default function useKpiSection() {
  const store = useStore();

  const courses = ref([]);
  const startDate = ref(moment().startOf("month").format("YYYY-MM-DD"));
  const endDate = ref(moment().format("YYYY-MM-DD"));

  const primaryCourses = computed(
    () => store.getters["courses/getCourseNames"]
  );
  const error = computed(() => store.getters["kpis/getError"]);
  const loading = computed(() => store.getters["kpis/isLoading"]);

  const generateDisabled = computed(() => {
    return !startDate.value || !endDate.value;
  });

  onMounted(async () => {
    initializeDatepicker();
    getReport();
    await store.dispatch("courses/fetchCourseNames");
  });

  function initializeDatepicker() {
    $("#datepicker").daterangepicker(
      {
        startDate: moment().startOf("month"),
        endDate: moment(),
        maxDate: moment(),
        locale: {
          cancelLabel: "Clear",
          applyLabel: "Apply",
          format: "DD MMM YYYY",
        },
      },
      function (start, end) {
        startDate.value = start.format("YYYY-MM-DD");
        endDate.value = end.format("YYYY-MM-DD");
      }
    );
  }

  async function getReport() {
    const ids = courses.value.map((course) => course.id);
    const payload = {
      startDate: startDate.value,
      endDate: endDate.value,
      ids: ids,
    };
    await store.dispatch("kpis/generateReport", payload);
  }

  async function generateReport() {
    getReport();
    if (error.value) {
      store.dispatch("toastNotification/displayToast", {
        message: error,
        type: "error",
      });
    }
  }

  return {
    loading,
    courses,
    generateDisabled,
    primaryCourses,
    generateReport,
  };
}
